// extracted by mini-css-extract-plugin
export var clearButton = "Autocomplete-module--clear-button--f9e7a";
export var close = "Autocomplete-module--close--44739";
export var container = "Autocomplete-module--container--9458b";
export var darkVariant = "Autocomplete-module--dark-variant--d7489";
export var detachedMode = "Autocomplete-module--detached-mode--917e0";
export var disabled = "Autocomplete-module--disabled--e689f";
export var emptyResults = "Autocomplete-module--empty-results--7a6c6";
export var formInput = "Autocomplete-module--form-input--cae0d";
export var formInputWithTags = "Autocomplete-module--form-input-with-tags--14f01";
export var input = "Autocomplete-module--input--76a63";
export var inputLabel = "Autocomplete-module--input-label--afc4c";
export var inputWrapper = "Autocomplete-module--input-wrapper--e76be";
export var inputWrapperPrefix = "Autocomplete-module--input-wrapper-prefix--67501";
export var list = "Autocomplete-module--list--90a4b";
export var panel = "Autocomplete-module--panel--2bcf2";
export var panelContainer = "Autocomplete-module--panel-container--046ea";
export var scrollableContent = "Autocomplete-module--scrollable-content--07802";
export var sectionContainer = "Autocomplete-module--section-container--4667d";
export var sourceTitle = "Autocomplete-module--source-title--7c9d2";
export var tagsAndInputWrapper = "Autocomplete-module--tags-and-input-wrapper--97d45";
export var titaniumPlaceholder = "Autocomplete-module--titanium-placeholder--12ed8";
export var whiteVariant = "Autocomplete-module--white-variant--05fd7";